/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Add, Cancel, Close, Save } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  FormControlLabel,
  Checkbox,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Form, FormikProvider, useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";

import PageContainer from "@jumbo/components/PageContainer";
import LoadingButton from "@jumbo/components/JumboLoadingButton";
import moment from "moment";
import { BILL_LIST } from "app/routes/constant";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import Loader from "@jumbo/components/Loader";
import { createVendor, getVendorList } from "app/redux/slice/vendorSlice";
import { getFabricList } from "app/redux/slice/fabricSlice";
import { createBill, getByIdBill, updateBill } from "app/redux/slice/billSlice";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import AddVendor from "app/pages/settings/vendor/add-vendor";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import Div from "@jumbo/shared/Div";

const useStyles = makeStyles({
  headingTitle: {
    minWidth: "80px",
  },
  table: {
    minWidth: 650,
    boxShadow: "none",
    "& .MuiTableCell-root": {
      boxShadow: "none",
      borderLeft: "1px solid",
      borderBottom: "1px solid",
    },
  },
  inputStyle: {
    "& .MuiInputLabel-formControl.Mui-disabled": {
      color: "#37373C !important",
      textFillColor: "#37373C !important",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#37373C !important",
      textFillColor: "#37373C !important",
    },
  },
  particular: {
    minWidth: "300px",
  },
  variants: {
    minWidth: "300px",
  },
  amount: {
    minWidth: "100px",
    verticalAlign: "top",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "end",
    margin: "6px 0px",
  },
  margin: {
    "& > :first-child": {
      marginTop: "10px",
    },
    marginBottom: "10px",
  },
  alignTop: {
    verticalAlign: "top",
  },
  loadingButtonContainer: {
    display: "flex",
    justifyContent: "end",
    marginTop: "20px",
  },
  imageUploadContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    padding: "5px",
    border: "2px dashed #ccc",
    borderRadius: "8px",
    minHeight: "120px",
    justifyContent: "center",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#1976d2",
    },
  },
  imagePreview: {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "8px",
  },
  hiddenInput: {
    display: "none",
  },
});
const deliveryTakenList = [
  {
    label: "Yes",
    _id: "yes",
  },
  {
    label: "No",
    _id: "no",
  },
];
const AddAndUpdateBillOther = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isOpen, onClose, onOpen, actionProps } = useDisclosure();

  const supplierData = useSelector((state) => state?.vendor);
  const fabricData = useSelector((state) => state?.fabric);
  const mobileView = useMediaQuery("(max-width:575px)");
  const [loading, setLoading] = useState(false);
  const [isLocal, setIsLocal] = useState(true);
  const [roundOff, setRoundOff] = useState(false);

  const validationSchema = yup.object({
    vendorId: yup.string().required("Please select a vendor").nullable(),
    // challanNumber: yup.string().required("Please enter challan number."),
    // challanDate: yup.string().required("Please select challan date."),
    // deliveryTaken: yup
    //   .string()
    //   .required("Please specify delivery taken.")
    //   .nullable(),
    dueDate: yup.string().required("Please enter a due date."),
    cgstPercentage: yup
      .number()
      .typeError("CGST percentage must be a number")
      .min(0, "CGST percentage must be 0 or greater")
      .max(100, "CGST percentage cannot exceed 100%")
      .when("$isLocal", {
        is: true,
        then: yup
          .number()
          .required("CGST percentage is required for local transactions"),
      }),
    sgstPercentage: yup
      .number()
      .typeError("SGST percentage must be a number")
      .min(0, "SGST percentage must be 0 or greater")
      .max(100, "SGST percentage cannot exceed 100%")
      .when("$isLocal", {
        is: true,
        then: yup
          .number()
          .required("SGST percentage is required for local transactions"),
      }),
    igstPercentage: yup
      .number()
      .typeError("IGST percentage must be a number")
      .min(0, "IGST percentage must be 0 or greater")
      .max(100, "IGST percentage cannot exceed 100%")
      .when("$isLocal", {
        is: false,
        then: yup
          .number()
          .required("IGST percentage is required for inter-state transactions"),
      }),
    items: yup.array().of(
      yup.object().shape({
        particulars: yup.string().required("Please enter a particular"),
        quantity: yup
          .number()
          .typeError("Quantity must be a number")
          .required("Please enter a quantity")
          .min(1, "Must be greater than or equal to 1"),
        rate: yup
          .number()
          .typeError("Rate must be a number")
          .required("Please enter a rate")
          .min(1, "Must be greater than or equal to 1"),
        amount: yup
          .number()
          .typeError("Amount must be a number")
          .required("Please enter an amount")
          .min(1, "Must be greater than or equal to 1"),
      })
    ),
  });

  const removeBlankStringKeys = (obj) =>
    Array.isArray(obj)
      ? obj.map(removeBlankStringKeys)
      : obj && typeof obj === "object"
      ? Object.fromEntries(
          Object.entries(obj)
            .filter(([_, v]) => v !== "")
            .map(([k, v]) => [k, removeBlankStringKeys(v)])
        )
      : obj;

  const formik = useFormik({
    initialValues: {
      createFor: "Other",
      vendorId: null,
      billDate: moment(new Date()).format("YYYY-MM-DD"),
      dueDate: moment().add(45, "days").format("YYYY-MM-DD"),
      challanNumber: "",
      challanDate: "",
      deliveryTaken: null,
      subTotal: 0,
      cgstPercentage: "",
      cgstAmount: 0,
      sgstPercentage: "",
      sgstAmount: 0,
      igstPercentage: "",
      igstAmount: 0,
      totalTaxAmount: 0,
      totalAmount: 0,
      discountAmount: 0,
      remark: "",
      items: [
        {
          particulars: "",
          quantity: "",
          rate: "",
          amount: "",
        },
      ],
    },
    validationSchema: validationSchema,
    context: { isLocal },
    validateOnChange: false,

    onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
      const newItems = removeBlankStringKeys(values?.items);
      const newValues = removeBlankStringKeys(values);
      newValues.roundOff = roundOff;
      const finalValues = { ...newValues, items: newItems };

      try {
        const response = await dispatch(
          id ? updateBill({ id, data: finalValues }) : createBill(finalValues)
        ).unwrap();

        if (response?.status === 200) {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "success",
          });
          navigate(BILL_LIST);
          resetForm();
        } else {
          enqueueSnackbar(response.data?.responseMessage, {
            variant: "error",
          });
        }
      } catch (error) {
        enqueueSnackbar(error?.data?.responseMessage, {
          variant: "error",
        });
      }
      setSubmitting(false);
    },
  });

  const { values, setFieldValue, errors, handleBlur } = formik;
  const { isSubmitting } = formik;

  const calculateTotalAmount = (items) => {
    return items.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
  };

  const calculateTaxAmounts = useCallback(
    (
      subTotal,
      cgstPercentage,
      sgstPercentage,
      igstPercentage,
      isLocal,
      roundOffLocal = false
    ) => {
      const subTotalNum = Number(subTotal) || 0;
      const cgstPercent = Number(cgstPercentage) || 0;
      const sgstPercent = Number(sgstPercentage) || 0;
      const igstPercent = Number(igstPercentage) || 0;

      let cgstAmount = 0;
      let sgstAmount = 0;
      let igstAmount = 0;
      let totalTaxAmount = 0;
      let totalAmount = 0;

      if (isLocal) {
        cgstAmount = (subTotalNum * cgstPercent) / 100;
        sgstAmount = (subTotalNum * sgstPercent) / 100;
        totalTaxAmount = cgstAmount + sgstAmount;
      } else {
        igstAmount = (subTotalNum * igstPercent) / 100;
        totalTaxAmount = igstAmount;
      }

      totalAmount = subTotalNum + totalTaxAmount;

      if (roundOffLocal) {
        cgstAmount = Math.round(cgstAmount);
        sgstAmount = Math.round(sgstAmount);
        igstAmount = Math.round(igstAmount);
        totalTaxAmount = Math.round(totalTaxAmount);
        totalAmount = Math.round(totalAmount);
      } else {
        cgstAmount = Math.round(cgstAmount * 100) / 100;
        sgstAmount = Math.round(sgstAmount * 100) / 100;
        igstAmount = Math.round(igstAmount * 100) / 100;
        totalTaxAmount = Math.round(totalTaxAmount * 100) / 100;
        totalAmount = Math.round((subTotalNum + totalTaxAmount) * 100) / 100;
      }

      return {
        cgstAmount,
        sgstAmount,
        igstAmount,
        totalTaxAmount,
        totalAmount,
      };
    },
    []
  );

  const handleChange = (index, field, value) => {
    let updatedFields = [...values.items];
    updatedFields[index][field] = value;

    if (field === "productId") {
      updatedFields[index].variantId = "";
    }

    if (field === "quantity" || field === "rate") {
      const quantity = Number(updatedFields[index].quantity) || 0;
      const rate = Number(updatedFields[index].rate) || 0;
      updatedFields[index].amount = quantity * rate;
    }

    const totalAmount = calculateTotalAmount(updatedFields);

    setFieldValue("items", updatedFields);
    setFieldValue("subTotal", totalAmount);

    const taxCalculations = calculateTaxAmounts(
      totalAmount,
      values.cgstPercentage,
      values.sgstPercentage,
      values.igstPercentage,
      isLocal,
      roundOff
    );

    setFieldValue("cgstAmount", taxCalculations.cgstAmount);
    setFieldValue("sgstAmount", taxCalculations.sgstAmount);
    setFieldValue("igstAmount", taxCalculations.igstAmount);
    setFieldValue("totalTaxAmount", taxCalculations.totalTaxAmount);
    setFieldValue("totalAmount", taxCalculations.totalAmount);

    if (field === "productId") {
      setFieldValue(`items[${index}].variantId`, "");
    }
  };

  const handleTaxChange = (field, value) => {
    const numValue = Number(value);
    if (isNaN(numValue) || numValue < 0) {
      return;
    }

    setFieldValue(field, numValue);

    const taxCalculations = calculateTaxAmounts(
      values.subTotal -
        (field === "discountAmount" ? numValue : values?.discountAmount),
      field === "cgstPercentage" ? numValue : values?.cgstPercentage,
      field === "sgstPercentage" ? numValue : values?.sgstPercentage,
      field === "igstPercentage" ? numValue : values?.igstPercentage,
      isLocal,
      roundOff
    );

    setFieldValue("cgstAmount", taxCalculations.cgstAmount);
    setFieldValue("sgstAmount", taxCalculations.sgstAmount);
    setFieldValue("igstAmount", taxCalculations.igstAmount);
    setFieldValue("totalTaxAmount", taxCalculations.totalTaxAmount);
    if (field === "discountAmount") {
      setFieldValue("totalAmount", taxCalculations?.totalAmount);
    }
  };

  const handleSubmitVendor = async (data) => {
    const newVendorData = {
      createFor: data?.createFor,
      name: data?.name?.trim(),
      address: data?.address?.trim(),
      phone: data?.phone?.trim(),
      gstNumber: data?.gstNumber?.trim(),
      panNumber: data?.panNumber?.trim(),
      city: data?.city?.trim(),
      state: data?.state?.trim(),
      email: data?.email?.trim(),
      pinCode: data?.pinCode,
    };

    const response = await dispatch(createVendor(newVendorData)).unwrap();
    if (response.status === 200) {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "success",
      });
      dispatch(getVendorList({ sort: 1, field: "name" }));
      onClose();
    } else {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch(getByIdBill(id))
        .unwrap()
        .then((response) => {
          if (response?.status === 200) {
            const billDetail = response?.data?.data;

            if (billDetail?.vendorId?.state === "Gujarat") {
              setIsLocal(true);
            } else {
              setIsLocal(false);
            }
            setFieldValue("vendorId", billDetail?.vendorId?._id);
            setFieldValue("remark", billDetail?.remark);
            setRoundOff(billDetail?.roundOff || false);
            setFieldValue(
              "billDate",
              billDetail?.billDate
                ? moment(billDetail?.billDate).format("YYYY-MM-DD")
                : ""
            );
            setFieldValue(
              "dueDate",
              moment(billDetail?.dueDate).format("YYYY-MM-DD")
            );
            setFieldValue(
              "challanDate",
              moment(billDetail?.challanDate).format("YYYY-MM-DD")
            );
            setFieldValue("challanNumber", billDetail?.challanNumber);
            setFieldValue("deliveryTaken", billDetail?.deliveryTaken);
            setFieldValue("billNo", billDetail?.billNo);
            setFieldValue("subTotal", billDetail?.subTotal || 0);
            setFieldValue("discountAmount", billDetail.discountAmount || 0);
            setFieldValue("cgstPercentage", billDetail?.cgstPercentage || 0);
            setFieldValue("sgstPercentage", billDetail?.sgstPercentage || 0);
            setFieldValue("igstPercentage", billDetail?.igstPercentage || 0);

            setFieldValue("cgstAmount", billDetail?.cgstAmount || 0);
            setFieldValue("sgstAmount", billDetail?.sgstAmount || 0);
            setFieldValue("igstAmount", billDetail?.igstAmount || 0);
            setFieldValue("totalTaxAmount", billDetail?.totalTaxAmount || 0);
            setFieldValue("totalAmount", billDetail?.totalAmount || 0);

            let productArr = [];
            for (let i = 0; i < billDetail?.items.length; i++) {
              const element = billDetail?.items[i];
              productArr?.push({
                particulars: element?.particulars,
                quantity: element?.quantity,
                rate: element?.rate,
                amount: element?.amount,
              });
            }
            setFieldValue("items", productArr);

            setLoading(false);
          } else {
            enqueueSnackbar(response.data?.responseMessage, {
              variant: "error",
            });
            setLoading(false);
          }
        });
    }
  }, []);

  useEffect(() => {
    dispatch(getVendorList({ sort: 1, field: "name" }));
    dispatch(getFabricList({ sort: 1, field: "name" }));
  }, []);

  useEffect(() => {
    if (values?.subTotal > 0) {
      const taxCalculations = calculateTaxAmounts(
        values?.subTotal,
        values?.cgstPercentage,
        values?.sgstPercentage,
        values?.igstPercentage,
        isLocal,
        roundOff
      );

      setFieldValue("cgstAmount", taxCalculations.cgstAmount);
      setFieldValue("sgstAmount", taxCalculations.sgstAmount);
      setFieldValue("igstAmount", taxCalculations.igstAmount);
      setFieldValue("totalTaxAmount", taxCalculations.totalTaxAmount);
      setFieldValue("totalAmount", taxCalculations.totalAmount);
    }
  }, [
    isLocal,
    values?.subTotal,
    values?.cgstPercentage,
    values?.sgstPercentage,
    values?.igstPercentage,
    roundOff,
    setFieldValue,
  ]);

  const handleDeleteField = (index) => {
    let updatedFields = [...values?.items];
    updatedFields.splice(index, 1);
    setFieldValue("items", updatedFields);
    const updatedSubTotal = calculateTotalAmount(updatedFields);

    setFieldValue("subTotal", updatedSubTotal);
    setFieldValue("totalAmount", updatedSubTotal - values?.discountAmount);
  };

  const handleAddMore = () => {
    const newItems = [
      ...formik.values.items,
      {
        particulars: "",
        quantity: "",
        rate: "",
        amount: "",
      },
    ];
    formik.setValues({
      ...formik.values,
      items: newItems,
      subTotal: calculateTotalAmount(newItems),
    });
  };

  const handleInitialTaxCalculation = useCallback(() => {
    if (values?.items?.length > 0) {
      const subTotal = calculateTotalAmount(values.items);
      setFieldValue("subTotal", subTotal);

      const taxCalculations = calculateTaxAmounts(
        subTotal,
        values?.cgstPercentage || 0,
        values?.sgstPercentage || 0,
        values?.igstPercentage || 0,
        isLocal,
        roundOff
      );

      setFieldValue("cgstAmount", taxCalculations.cgstAmount);
      setFieldValue("sgstAmount", taxCalculations.sgstAmount);
      setFieldValue("igstAmount", taxCalculations.igstAmount);
      setFieldValue("totalTaxAmount", taxCalculations.totalTaxAmount);
      setFieldValue("totalAmount", taxCalculations.totalAmount);
    }
  }, [
    calculateTaxAmounts,
    isLocal,
    roundOff,
    setFieldValue,
    values,
    calculateTotalAmount,
  ]);

  const handleRoundOffChange = (event) => {
    setRoundOff(event.target.checked);
    handleInitialTaxCalculation();
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <PageContainer heading={id ? "View Bill" : "Add Bill"}>
          <Card>
            <CardContent>
              <FormikProvider value={formik}>
                <Form
                  noValidate
                  autoComplete="off"
                  onSubmit={formik.handleSubmit}
                >
                  <Grid container border={1}>
                    <Grid sm={3} xs={12} borderRight={{ xs: 0, sm: 1 }} p={1}>
                      <Div style={{ display: "flex", alignItems: "center" }}>
                        <JumboAutoComplete
                          options={supplierData?.list ?? []}
                          label="Vendor*"
                          size="small"
                          sx={{ width: "100%" }}
                          getOptionLabel={(option) => option?.name}
                          name={"vendorId"}
                          value={supplierData?.list?.find(
                            (item) => item?._id === values?.vendorId
                          )}
                          className={classes?.inputStyle}
                          onChange={(evt, value) => {
                            setFieldValue("vendorId", value?._id);

                            // Set default tax percentages based on vendor state
                            if (value?.state === "Gujarat") {
                              setFieldValue("cgstPercentage", 9);
                              setFieldValue("sgstPercentage", 9);
                              setFieldValue("igstPercentage", "");
                              setIsLocal(true);
                            } else {
                              setFieldValue("cgstPercentage", "");
                              setFieldValue("sgstPercentage", "");
                              setFieldValue("igstPercentage", 18);
                              setIsLocal(false);
                            }

                            // Recalculate tax amounts
                            const taxCalculations = calculateTaxAmounts(
                              values.subTotal,
                              value?.state === "Gujarat" ? 9 : 0,
                              value?.state === "Gujarat" ? 9 : 0,
                              value?.state === "Gujarat" ? 0 : 18,
                              value?.state === "Gujarat",
                              roundOff
                            );

                            setFieldValue(
                              "cgstAmount",
                              taxCalculations.cgstAmount
                            );
                            setFieldValue(
                              "sgstAmount",
                              taxCalculations.sgstAmount
                            );
                            setFieldValue(
                              "igstAmount",
                              taxCalculations.igstAmount
                            );
                            setFieldValue(
                              "totalTaxAmount",
                              taxCalculations.totalTaxAmount
                            );
                            setFieldValue(
                              "totalAmount",
                              taxCalculations.totalAmount
                            );
                          }}
                          helperText={formik?.errors?.vendorId}
                          isOptionEqualToValue={(option, value) =>
                            option?._id === value?._id
                          }
                        />
                        <IconButton
                          onClick={() => {
                            onOpen();
                          }}
                        >
                          <Add />
                        </IconButton>
                      </Div>
                    </Grid>
                    <Grid sm={3} xs={12} borderRight={{ xs: 0, sm: 1 }} p={1}>
                      <TextField
                        label={"Bill no"}
                        name="billNo"
                        fullWidth
                        size="small"
                        onChange={(evt) =>
                          setFieldValue("billNo", evt.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                        value={values?.billNo}
                        className={classes?.inputStyle}
                      />
                    </Grid>

                    <Grid
                      item
                      sm={3}
                      xs={12}
                      borderRight={{ xs: 0, sm: 1 }}
                      p={1}
                    >
                      <TextField
                        label={"Date"}
                        name="billDate"
                        fullWidth
                        size="small"
                        type="date"
                        onChange={(evt) => {
                          setFieldValue("billDate", evt.target.value);
                          setFieldValue(
                            "dueDate",
                            moment(evt.target.value)
                              .add(45, "days")
                              .format("YYYY-MM-DD")
                          );
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={values?.billDate}
                        error={errors?.billDate}
                        className={classes?.inputStyle}
                        helperText={errors?.billDate}
                      />
                    </Grid>
                    <Grid item sm={3} xs={12} p={1}>
                      <TextField
                        label={"Due Date*"}
                        name="dueDate"
                        fullWidth
                        size="small"
                        type="date"
                        onChange={(evt) =>
                          setFieldValue("dueDate", evt.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                        value={values?.dueDate}
                        error={errors?.dueDate}
                        className={classes?.inputStyle}
                        helperText={errors?.dueDate}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      xs={12}
                      borderRight={{ xs: 0, sm: 1 }}
                      borderTop={{ xs: 0, sm: 1 }}
                      p={1}
                    >
                      <TextField
                        label={"Challan No"}
                        name="challanNumber"
                        fullWidth
                        size="small"
                        onChange={(evt) =>
                          setFieldValue("challanNumber", evt.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                        value={values?.challanNumber}
                        error={errors?.challanNumber}
                        className={classes?.inputStyle}
                        helperText={errors?.challanNumber}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      xs={12}
                      borderRight={{ xs: 0, sm: 1 }}
                      borderTop={{ xs: 0, sm: 1 }}
                      p={1}
                    >
                      <TextField
                        label={"Challan Date"}
                        name="challanDate"
                        fullWidth
                        size="small"
                        type="date"
                        onChange={(evt) =>
                          setFieldValue("challanDate", evt.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                        value={values?.challanDate}
                        error={errors?.challanDate}
                        className={classes?.inputStyle}
                        helperText={errors?.challanDate}
                      />
                    </Grid>
                    <Grid sm={4} xs={12} borderTop={{ xs: 0, sm: 1 }} p={1}>
                      <JumboAutoComplete
                        options={deliveryTakenList ?? []}
                        label="Delivery Taken"
                        size="small"
                        getOptionLabel={(option) => option?.label}
                        name={"deliveryTaken"}
                        value={deliveryTakenList?.find(
                          (item) => item?._id === values?.deliveryTaken
                        )}
                        className={classes?.inputStyle}
                        onChange={(evt, value) => {
                          setFieldValue("deliveryTaken", value?._id);
                        }}
                        helperText={formik?.errors?.deliveryTaken}
                        isOptionEqualToValue={(option, value) =>
                          option?._id === value?._id
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    borderRight={1}
                    sx={{
                      mt: { xs: 3, md: 0 },
                    }}
                    className="mobile-view-table"
                  >
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 650 }}
                        size="small"
                        aria-label="a dense table"
                        className={`${classes?.table}`}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr. No.</TableCell>
                            <TableCell style={{ minWidth: "200px" }}>
                              Particulars
                            </TableCell>
                            <TableCell style={{ minWidth: "120px" }}>
                              Quantity
                            </TableCell>
                            <TableCell style={{ minWidth: "170px" }}>
                              Rate
                            </TableCell>
                            <TableCell
                              style={{ minWidth: "160px", textAlign: "end" }}
                            >
                              Amount
                            </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values?.items?.length &&
                            fabricData?.list?.length &&
                            values?.items?.map((item, index) => {
                              return (
                                <TableRow key={index}>
                                  <TableCell
                                    className={classes?.alignTop}
                                    sx={{ width: "10px", paddingTop: "20px" }}
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell className={`${classes?.alignTop}`}>
                                    <TextField
                                      sx={{ marginTop: "7px" }}
                                      placeholder="Qty"
                                      label="Particular*"
                                      name={`items[${index}].particulars`}
                                      fullWidth
                                      value={item?.particulars}
                                      size="small"
                                      onChange={(evt) =>
                                        handleChange(
                                          index,
                                          "particulars",
                                          evt.target.value
                                        )
                                      }
                                      className={classes?.inputStyle}
                                      error={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.particulars
                                      }
                                      helperText={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.particulars
                                      }
                                    />
                                  </TableCell>
                                  <TableCell className={`${classes?.alignTop}`}>
                                    <TextField
                                      sx={{ marginTop: "7px" }}
                                      placeholder="Qty"
                                      label="Qty*"
                                      name={`items[${index}].quantity`}
                                      fullWidth
                                      value={item?.quantity}
                                      size="small"
                                      type="number"
                                      onChange={(evt) =>
                                        handleChange(
                                          index,
                                          "quantity",
                                          +evt.target.value
                                        )
                                      }
                                      className={classes?.inputStyle}
                                      error={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.quantity
                                      }
                                      helperText={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.quantity
                                      }
                                    />
                                  </TableCell>
                                  <TableCell className={`${classes?.alignTop}`}>
                                    <TextField
                                      sx={{ marginTop: "7px" }}
                                      placeholder="Rate"
                                      label="Rate*"
                                      name={`items[${index}].rate`}
                                      fullWidth
                                      value={item?.rate}
                                      size="small"
                                      type="number"
                                      onChange={(evt) =>
                                        handleChange(
                                          index,
                                          "rate",
                                          +evt.target.value
                                        )
                                      }
                                      className={classes?.inputStyle}
                                      error={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.rate
                                      }
                                      helperText={
                                        errors?.items?.length &&
                                        errors?.items?.[index]?.rate
                                      }
                                    />
                                  </TableCell>
                                  <TableCell
                                    sx={{ width: "10px", textAlign: "end" }}
                                  >
                                    {item?.amount || 0}
                                  </TableCell>
                                  <TableCell sx={{ width: "10px" }}>
                                    {values?.items?.length > 1 && (
                                      <IconButton
                                        aria-label="delete"
                                        color="secondary"
                                        onClick={() => handleDeleteField(index)}
                                      >
                                        <Cancel />
                                      </IconButton>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          <TableRow>
                            <TableCell colSpan={5}>
                              <TextField
                                sx={{ marginTop: "7px" }}
                                placeholder="Remark"
                                label="Remark"
                                name={`remark`}
                                fullWidth
                                value={values?.remark}
                                size="small"
                                onChange={(evt) =>
                                  setFieldValue("remark", evt.target.value)
                                }
                              />
                            </TableCell>
                            <TableCell>
                              <Grid className={classes?.buttonContainer}>
                                <LoadingButton
                                  style={{ minWidth: "100px" }}
                                  type="button"
                                  buttonLabel={"Add"}
                                  startIcon={<Add />}
                                  variant="outlined"
                                  onClick={handleAddMore}
                                  className="add-btn"
                                />
                              </Grid>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={roundOff}
                            onChange={async (e) => {
                              await setRoundOff(e.target.checked);
                              // Recalculate amounts when roundoff changes
                              const subTotal = await calculateTotalAmount(
                                values.items
                              );
                              const taxAmounts = await calculateTaxAmounts(
                                subTotal - (values?.discountAmount || 0),
                                values.cgstPercentage || 0,
                                values.sgstPercentage || 0,
                                values.igstPercentage || 0,
                                isLocal,
                                e.target.checked
                              );

                              await setFieldValue(
                                "cgstAmount",
                                taxAmounts.cgstAmount
                              );
                              await setFieldValue(
                                "sgstAmount",
                                taxAmounts.sgstAmount
                              );
                              await setFieldValue(
                                "igstAmount",
                                taxAmounts.igstAmount
                              );
                              await setFieldValue(
                                "totalTaxAmount",
                                taxAmounts.totalTaxAmount
                              );
                              await setFieldValue(
                                "totalAmount",
                                taxAmounts.totalAmount
                              );
                            }}
                            color="primary"
                          />
                        }
                        label="Round Off Tax Values"
                      />
                    </Box>
                  </Grid>
                  <Grid container border={1} borderTop={0}>
                    {isLocal ? (
                      <>
                        <Grid
                          sm={3}
                          xs={12}
                          borderRight={{ xs: 0, sm: 1 }}
                          p={1.2}
                        >
                          <TextField
                            className={classes?.inputStyle}
                            label={"CGST(%)*"}
                            name="cgstPercentage"
                            fullWidth
                            size="small"
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            onChange={(evt) =>
                              handleTaxChange(
                                "cgstPercentage",
                                +evt.target.value
                              )
                            }
                            onBlur={async (e) => {
                              handleBlur(e);
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values?.cgstPercentage}
                            error={errors?.cgstPercentage}
                            helperText={errors?.cgstPercentage}
                          />
                        </Grid>
                        <Grid
                          sm={3}
                          xs={12}
                          borderRight={{ xs: 0, sm: 1 }}
                          p={1.2}
                        >
                          <TextField
                            label={"CGST Amount"}
                            className={classes?.inputStyle}
                            name="cgstAmount"
                            fullWidth
                            size="small"
                            type="number"
                            InputLabelProps={{ shrink: true }}
                            value={values?.cgstAmount}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>
                        <Grid
                          sm={3}
                          xs={12}
                          borderRight={{ xs: 0, sm: 1 }}
                          p={1.2}
                        >
                          <TextField
                            label={"SGST(%)*"}
                            className={classes?.inputStyle}
                            name="sgstPercentage"
                            fullWidth
                            size="small"
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            onChange={(evt) =>
                              handleTaxChange(
                                "sgstPercentage",
                                +evt.target.value
                              )
                            }
                            onBlur={async (e) => {
                              handleBlur(e);
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values?.sgstPercentage}
                            error={errors?.sgstPercentage}
                            helperText={errors?.sgstPercentage}
                          />
                        </Grid>
                        <Grid
                          sm={3}
                          xs={12}
                          borderRight={{ xs: 0, sm: 0 }}
                          p={1.2}
                        >
                          <TextField
                            className={classes?.inputStyle}
                            label={"SGST Amount"}
                            name="sgstAmount"
                            fullWidth
                            size="small"
                            type="number"
                            InputLabelProps={{ shrink: true }}
                            value={values?.sgstAmount}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid
                          sm={6}
                          xs={12}
                          borderRight={{ xs: 0, sm: 1 }}
                          p={1.2}
                        >
                          <TextField
                            label={"IGST(%)*"}
                            className={classes?.inputStyle}
                            name="igstPercentage"
                            fullWidth
                            size="small"
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            onChange={(evt) =>
                              handleTaxChange(
                                "igstPercentage",
                                +evt.target.value
                              )
                            }
                            onBlur={async (e) => {
                              handleBlur(e);
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values?.igstPercentage}
                            error={errors?.igstPercentage}
                            helperText={errors?.igstPercentage}
                          />
                        </Grid>
                        <Grid
                          sm={6}
                          xs={12}
                          borderRight={{ xs: 0, sm: 0 }}
                          p={1.2}
                        >
                          <TextField
                            className={classes?.inputStyle}
                            label={"IGST Amount"}
                            name="igstAmount"
                            fullWidth
                            size="small"
                            type="number"
                            InputLabelProps={{ shrink: true }}
                            value={values?.igstAmount}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                  <Grid
                    container
                    border={1}
                    borderTop={0}
                    sx={{ fontWeight: 500 }}
                  >
                    <Grid sm={6} xs={12} borderRight={{ xs: 0, sm: 1 }} p={1.2}>
                      Discount Amount
                    </Grid>
                    <Grid
                      sm={6}
                      xs={12}
                      textAlign={"right"}
                      borderRight={{ xs: 0, sm: 0 }}
                      p={1.2}
                    >
                      <TextField
                        className={classes?.inputStyle}
                        label="Discount Amount"
                        name="discountAmount"
                        size="small"
                        type="number"
                        min="0"
                        onChange={(evt) =>
                          handleTaxChange("discountAmount", +evt.target.value)
                        }
                        onBlur={async (e) => {
                          handleBlur(e);
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={values?.discountAmount || 0}
                        error={errors?.discountAmount}
                        helperText={errors?.discountAmount}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    border={1}
                    borderTop={0}
                    sx={{ fontWeight: 500 }}
                  >
                    <Grid sm={6} xs={12} borderRight={{ xs: 0, sm: 1 }} p={1.2}>
                      Sub Total Amount
                    </Grid>
                    <Grid
                      sm={6}
                      xs={12}
                      textAlign={"right"}
                      borderRight={{ xs: 0, sm: 0 }}
                      p={1.2}
                    >
                      {values?.subTotal - (values?.discountAmount ?? 0) || 0}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    border={1}
                    borderTop={0}
                    sx={{ fontWeight: 500 }}
                  >
                    <Grid sm={6} xs={12} borderRight={{ xs: 0, sm: 1 }} p={1.2}>
                      Total Tax Amount
                    </Grid>
                    <Grid
                      sm={6}
                      xs={12}
                      textAlign={"right"}
                      borderRight={{ xs: 0, sm: 0 }}
                      p={1.2}
                    >
                      {values?.totalTaxAmount || 0}
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    border={1}
                    borderTop={0}
                    sx={{ fontWeight: 500 }}
                  >
                    <Grid sm={6} xs={12} borderRight={{ xs: 0, sm: 1 }} p={1.2}>
                      Total Amount
                    </Grid>
                    <Grid
                      sm={6}
                      xs={12}
                      textAlign={"right"}
                      borderRight={{ xs: 0, sm: 0 }}
                      p={1.2}
                    >
                      {values?.totalAmount || 0}
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid
                      item
                      sm={12}
                      xs={12}
                      className={classes?.loadingButtonContainer}
                    >
                      <LoadingButton
                        type="submit"
                        buttonLabel={"Save"}
                        sx={{ marginRight: "10px" }}
                        startIcon={<Save />}
                        variant="outlined"
                        fullWidth={mobileView}
                        loading={isSubmitting}
                      />
                      <LoadingButton
                        color={"secondary"}
                        buttonLabel={"Close"}
                        variant="outlined"
                        startIcon={<Close />}
                        onClick={() => navigate(BILL_LIST)}
                        fullWidth={mobileView}
                      />
                    </Grid>
                  </Grid>
                </Form>
              </FormikProvider>
            </CardContent>
          </Card>
          <DialogDefault
            open={isOpen}
            onClose={onClose}
            content={
              <AddVendor
                value={actionProps}
                onClose={onClose}
                handleSubmit={handleSubmitVendor}
              />
            }
            title={"Add Vendor / Party"}
            fullWidth={true}
            maxWidth={"md"}
            actions={<></>}
          />
        </PageContainer>
      )}
    </>
  );
};

export default AddAndUpdateBillOther;
